export default __webpack_public_path__ + "images/BT.baebbef.png";